<style lang="scss" scoped>
.slide-16 {
  background-image: url(../../../assets/module3/slide16/background-01.jpg);
  background-position: center;
  background-size: cover;
  background-color: #fff;
  height: calc(100% - 90px);
  padding-left: 70px;
  padding-top: 90px;

  .heading1 {
    color: #f8dc61;
    font-size: 195px;
    margin: auto;
    transform: rotate(-5deg);
  }
  h2 {
    font-size: 58px;
  }
  .heading2 {
    margin-bottom: 35px;
  }
  .heading3 {
    color: #c5d43b;
  }
  .heading5 {
    width: 800px;
    text-align: center;
    transform: translateX(-85px);
  }
  p {
    color: #ffffff;
    margin-bottom: 55px;
    max-width: 700px;
    margin-top: -20px;
  }
  .close {
    position: absolute;
    width: 100px;
    right: 10px;
    bottom: 10px;
    z-index: 10;
    cursor: pointer;
  }
}
</style>

<template>
  <div class="slide-16">
    <transition name="scale" appear>
      <div v-show="slideIndex == 15">
        <h1 class="heading1">
          {{ $t("module3.slide16.heading1") }}
        </h1>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <img
        class=" chars"
        v-show="slideIndex == 15"
        src="@/assets/module3/slide16/armando_timmy-01.png"
      />
    </transition>
    <div class="pages">
      <div class="page page-left"></div>
      <div class="page page-right">
        <transition name="fadeUp" appear>
          <p
            v-html="$t('module3.slide16.copy1')"
            class="delay-2"
            v-show="slideIndex == 15"
          ></p>
        </transition>
        <transition name="fadeUp" appear>
          <p
            v-html="$t('module3.slide16.copy2')"
            class="delay-3"
            v-show="slideIndex == 15"
          ></p>
        </transition>
        <transition name="fadeUp" appear>
          <h2
            class="heading2 delay-4"
            v-html="$t('module3.slide16.heading2')"
            v-show="slideIndex == 15"
          ></h2>
        </transition>
        <transition name="fadeUp" appear>
          <h2
            class="heading3 delay-5"
            v-html="$t('module3.slide16.heading3')"
            v-show="slideIndex == 15"
          ></h2>
        </transition>
        <transition name="fadeUp" appear>
          <h2
            class="heading4 delay-6"
            v-html="$t('module3.slide16.heading4')"
            v-show="slideIndex == 15"
          ></h2>
        </transition>
        <transition name="fadeUp" appear>
          <div class="delay-7" v-show="slideIndex == 15">
            <h2 class="heading5" v-html="$t('module3.slide16.heading5')"></h2>
          </div>
        </transition>
      </div>
    </div>
    <img
      @click.prevent="reload()"
      class="close"
      src="@/assets/module1/slide27/button_close.png"
    />
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  methods: {
    reload() {
      window.location = "/e-books/";
    }
  }
};
</script>
